var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app","dir":""}},[_c('div',{staticClass:"loading-screen",class:{show : _vm.appLoading}},[_c('svg',{staticClass:"spinner"},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"18"}})])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }